<template>
  <template v-for="(segment, index) in segments" :key="index">
    <span v-if="segment.phrase" title="Phrase" class="border-b-[1.5px] border-dotted border-iris">{{
      segment.text
    }}</span>
    <template v-else>{{ segment.text }}</template>
  </template>
</template>

<script setup lang="ts">
import type { PhraseSegment } from '@dashboard/services/phraseText'

defineProps<{ segments: PhraseSegment[] }>()
</script>
